import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import Cookies from "js-cookie";
const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();
        useEffect(() => {
        console.log('Login component rendered');
        handleLogin();
    }, []);

    const handleLogin = async () => {
        try {
            const urlParams = new URLSearchParams(location.search);
            const token = urlParams.get('token');
            if (!token) {
                Swal.fire({
                    icon: 'error',
                    title: 'Login Error',
                    text: 'An error occurred during login',
                    showConfirmButton: true,
                    confirmButtonText: 'OK'
                });
                return;
            }

            Cookies.set("jwt_token", token);
            Swal.fire({
                icon: 'success',
                title: 'Login Successful',
                text: 'Success',
                showConfirmButton: true,
                confirmButtonText: 'OK'
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.href = '/';
                }
            });

        } catch (error) {
            console.error('Error after login:', error);
            Swal.fire({
                icon: 'error',
                title: 'Login Error',
                text: 'An error occurred during login',
                showConfirmButton: true,
                confirmButtonText: 'OK'
            });
        }
    };
   
};

export default Login;
